<template>
  <div class="indexContainer">
    <Header @accept="childaccept" :nav="nav"></Header>
    <IndexMain v-if="type == 0"></IndexMain>
    <About v-if="type == 1"></About>
    <Joinus v-if="type == 2"></Joinus>
    <ContactUs v-if="type == 3"></ContactUs>
    <div v-if="type == 4">
      <!-- banner -->
      <!-- <div style="width: 100%; height: 600px">
        <img
          style="width: 100%; height: 100%"
          src="@/images/common/banner.png"
          alt=""
        />
      </div> -->
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "@/components/header/header";
import IndexMain from "@/components/indexMain/index";
import Joinus from "@/components/joinus/index";
import ContactUs from "@/components/ContactUs/index";
import About from "@/components/About/index";
import Footer from "@/components/footer/footer";

export default {
  data() {
    return {
      // bground:'none'

      nav: [
        {
          id: 1,
          name: "首页",
          isfalse: true,
          path: "index",
        },
        {
          id: 2,
          name: "关于我们",
          isfalse: false,
          path: "aboutUs2",
        },
        {
          id: 3,
          name: "加入我们",
          isfalse: false,
          path: "joinus",
        },
        
        {
          id: 4,
          name: "联系我们",
          isfalse: false,
          path: "group",
        },
      ],
      type: "0",
    };
  },
  components: {
    Header,
    IndexMain,
    Joinus,
    ContactUs,
    About,
    Footer,
  },
  computed: {
    src() {
      // if (process.env.BASE_SYSTEM === "devops_dev") {
      //   return "http://0.0.0.0:8888/alerts_confirm";
      // }
      return "http://47.96.118.196:804/#/bs/order-svc-no-login";
    },
  },
  mounted() {
    // this.iframeWin = this.$refs.iframe.contentWindow;
  },

  methods: {
    childaccept(val) {
      this.type = val;
      // console.log('val',val)
    },
    // loaded() {
    //   const cookie = document.cookie;
    //   this.iframeWin.postMessage(cookie, this.src);
    // },
  },
};
</script>

<style scoped>
.indexContainer {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue